import api from "./api";

// Get all academic terms (centralized - not branch-specific)
export const getAcademicTerms = async () => {
  try {
    const response = await api.get("/academic-terms");
    return {
      success: true,
      data: response.data || [],
      pagination: response.pagination,
    };
  } catch (error: any) {
    console.error("Error fetching academic terms:", error);
    return {
      success: false,
      data: [],
      error: error.response?.data?.message || "Failed to fetch academic terms",
    };
  }
};

// Get single academic term
export const getAcademicTerm = async (id: string) => {
  try {
    const response = await api.get(`/academic-terms/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    console.error("Error fetching academic term:", error);
    throw error;
  }
};

// Get active academic term
export const getActiveTerm = async () => {
  try {
    const response = await api.get("/academic-terms/active");
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    console.error("Error fetching active term:", error);
    return {
      success: false,
      data: null,
      error: error.response?.data?.message || "Failed to fetch active term",
    };
  }
};

// Get current academic term
export const getCurrentTerm = async () => {
  try {
    const response = await api.get("/academic-terms/current");
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    console.error("Error fetching current term:", error);
    return {
      success: false,
      data: null,
      error: error.response?.data?.message || "Failed to fetch current term",
    };
  }
};

// Create academic term (super admin only)
export const createAcademicTerm = async (termData: any) => {
  try {
    const response = await api.post("/academic-terms", termData);
    return {
      success: true,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    console.error("Error creating academic term:", error);
    throw error;
  }
};

// Update academic term (super admin only)
export const updateAcademicTerm = async (id: string, termData: any) => {
  try {
    const response = await api.put(`/academic-terms/${id}`, termData);
    return {
      success: true,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    console.error("Error updating academic term:", error);
    throw error;
  }
};

// Delete academic term (super admin only)
export const deleteAcademicTerm = async (id: string) => {
  try {
    const response = await api.delete(`/academic-terms/${id}`);
    return {
      success: true,
      message: response.message,
    };
  } catch (error: any) {
    console.error("Error deleting academic term:", error);
    throw error;
  }
};

// Activate academic term (super admin only)
export const activateAcademicTerm = async (id: string) => {
  try {
    const response = await api.put(`/academic-terms/${id}/activate`);
    return {
      success: true,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    console.error("Error activating academic term:", error);
    throw error;
  }
};

// Set current academic term (super admin only)
export const setCurrentAcademicTerm = async (id: string) => {
  try {
    const response = await api.put(`/academic-terms/${id}/set-current`);
    return {
      success: true,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    console.error("Error setting current academic term:", error);
    throw error;
  }
};

// Archive academic term (super admin only)
export const archiveAcademicTerm = async (id: string) => {
  try {
    const response = await api.put(`/academic-terms/${id}/archive`);
    return {
      success: true,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    console.error("Error archiving academic term:", error);
    throw error;
  }
};
